import { Suspense } from 'react';

export const withSuspense = (Component: React.LazyExoticComponent<any>, props?: Record<string, unknown>) => {
  return (
    <Suspense>
      <Component {...props} />
    </Suspense>
  );
};
